var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"label":_vm.$t(_vm.label),"prepend-icon":"insert_chart","value":_vm.value,"items":_vm.statuses,"multiple":"","clearable":"","disabled":_vm.disabled},on:{"input":_vm.selectStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }